export default {
    path: '/recharge',
    meta: {
        title: '充值记录',
    },
    component: r => require.ensure([], () => r(require(`./index.vue`)), `/recharge`),
}


// WEBPACK FOOTER //
// ./src/views/Recharge/router.js